/** Shared required-field validation + scroll-to-invalid helpers */

export const isEmptyValue = (value) => {
  if (value == null) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (value instanceof Date) return Number.isNaN(value.getTime());
  return String(value).trim() === "";
};

/**
 * @param {{ key: string, value: any, label: string, message?: string }[]} fields
 * @returns {Record<string, string>}
 */
export const validateRequiredFields = (fields = []) => {
  const errors = {};
  for (const { key, value, label, message } of fields) {
    if (isEmptyValue(value)) {
      errors[key] = message || `${label} is required`;
    }
  }
  return errors;
};

export const firstErrorMessage = (errors = {}) => {
  const key = Object.keys(errors)[0];
  return key ? errors[key] : "";
};

/**
 * Scrolls to and focuses the first invalid control.
 * Looks up by [name], #id, then [data-field] within optional root selector.
 */
export const focusFirstInvalidField = (errors = {}, options = {}) => {
  const { rootSelector, order } = options;
  const keys = Array.isArray(order) && order.length
    ? order.filter((k) => errors[k])
    : Object.keys(errors);
  const firstKey = keys[0];
  if (!firstKey) return;

  window.setTimeout(() => {
    const scope = rootSelector
      ? document.querySelector(rootSelector)
      : document;
    if (!scope) return;

    const escaped = typeof CSS !== "undefined" && CSS.escape
      ? CSS.escape(firstKey)
      : firstKey.replace(/"/g, '\\"');

    const el =
      scope.querySelector(`[name="${escaped}"]`) ||
      scope.querySelector(`#${escaped}`) ||
      scope.querySelector(`[data-field="${escaped}"]`);

    if (!el) return;

    el.scrollIntoView({ behavior: "smooth", block: "center" });
    if (typeof el.focus === "function") {
      try {
        el.focus({ preventScroll: true });
      } catch {
        el.focus();
      }
    }
  }, 80);
};

export const withInvalidClass = (baseClass = "", hasError = false) =>
  `${baseClass}${hasError ? " is-invalid" : ""}`.trim();
